import { render, staticRenderFns } from "./SendFileOnebox.vue?vue&type=template&id=5d22f50a&scoped=true&lang=html&"
import script from "./SendFileOnebox.vue?vue&type=script&lang=js&"
export * from "./SendFileOnebox.vue?vue&type=script&lang=js&"
import style0 from "./SendFileOnebox.vue?vue&type=style&index=0&id=5d22f50a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22f50a",
  null
  
)

export default component.exports